module.exports = __webpack_public_path__ + "static/img/kj1-10.e2c4df9.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-10.png
// module id = 932
// module chunks = 0